import { render, staticRenderFns } from "./OriginalSharesEditPanelDialog.vue?vue&type=template&id=cbc3138e"
import script from "./OriginalSharesEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./OriginalSharesEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports